import api from 'api'
import { PaymentProvider } from './getUserPaymentProfile'

// The 1099 payment provider can only be overridden between Stripe and Highnote.
export type PaymentProvider1099 = Extract<
  PaymentProvider,
  'stripe' | 'highnote'
>

export type UpdatePaymentProvider1099Options = {
  userId: number
  paymentProvider1099: PaymentProvider1099
}

export const updatePaymentProvider1099 = async ({
  userId,
  paymentProvider1099,
}: UpdatePaymentProvider1099Options): Promise<void> => {
  await api.patch(`/admin/user_payments/${userId}/payment_provider_1099`, {
    paymentProvider1099,
  })
}
